<template>
  <div class="web-video-containter">
    <audio id="cameraAudio" src="../../assets/audio/cameraShutter.mp3"></audio>
    <div class="close-web-camera" @click="close">
      <i  class='bx bx-x'></i>
    </div>
    <div class="switch-camera">
      <div class="switch-camera-wrapper">
        <i class="bx bx-camera" @click="switchCamera"></i>
        <div class="switch-number"> {{(currentCameraMode === 'user') ? 2 : 1}}</div>
      </div>
    </div>
    <template>
      <video autoplay muted playsinline id="preview" :class="{'user-mode': currentCameraMode !== 'environment'}"></video>
    </template>

    <div class="actions">
      <div class="" style="flex: 1; text-align: center">
        <button type="button" id="take-photo" :class="{'red-take-photo': isRecording}" class="btn-shot" @click="onTakePhotoClick" tabindex="1"></button>
      </div>
    </div>
  </div>
</template>


<script>
import Axios from "axios";
import _ from "lodash";

export default {
  name: "webCamera",
  data() {
    return {
      isRecording: false,
      activeVideoStream: null,
      savedImgCount: 0,
      unsavedImgCount: 0,
      currentCameraMode: 'environment',
      isClickedClose: false,
      photos: []
    }
  },
  mounted() {
    this.startVideo()
    this.$fullscreen.toggle(document.body, {
      wrap: false,
    });
  },
  methods: {
    close() {
      if (this.savedImgCount == this.unsavedImgCount) {
        this.$fullscreen.toggle(document.body, {
          wrap: false,
          callback: this.emitClose()
        });
      } else {
        let interval = setInterval(() => {
          this.isClickedClose = true
          if (this.savedImgCount == this.unsavedImgCount) {
            clearInterval(interval)
            this.$fullscreen.toggle(document.body, {
              wrap: false,
              callback: this.emitClose()
            });
            this.isClickedClose = false
          }
        }, 10)
      }
    },
    emitClose() {
      if (this.activeVideoStream) {
        this.activeVideoStream.getTracks().forEach(track => track.stop());
      }
      this.$emit('close', this.photos)
    },
    onClickDone(id) {
      let data = {}
      let uid = Date.now().toString() + Math.random().toString(36).substr(2, 4)
      data[uid] = {}
      data[uid].image_ids = [id]
      data[uid].imagesSort =[{
        id: id,
        index: 0,
      }]
      Axios({
        method: 'post',
        responseType: 'json',
        headers: { 'Autosave': true },
        url: `/fe/estimate/1`,
        validateStatus: function (status) {
          return status < 500
        },
        data: data
      })
          .then((r) => {
            if (r.status === 200) {
              // this.savedImgCount++
            }
          })
          .finally(() => {
            NProgress.done()
          })

    },
    switchCamera() {
      this.updateActiveCameraSelection()
    },
    async updateActiveCameraSelection() {
      try {
        this.currentCameraMode = (this.currentCameraMode === 'user') ? 'environment' : 'user';
        this.startVideo()
      } catch (error) {
        this.saveError(error)
      }
    },
    saveError(e) {
      Axios.post('/fe/logs/front', {error: String(e)}).then(r => {
      })
    },
    createThumbnail(video, scaleFactor) {
      if (scaleFactor == null) {
        scaleFactor = 1;
      }
      let w = video.videoWidth * scaleFactor;
      let h = video.videoHeight * scaleFactor;
      let canvas = document.createElement("canvas");
      canvas.style.margin = "5px";
      canvas.width = w;
      canvas.height = h;

      let ctx = canvas.getContext("2d");

      if (this.currentCameraMode !== 'environment') {
        ctx.translate(w, 0);
        ctx.scale(-1, 1);
      }
      ctx.drawImage(video, 0, 0, w, h);
      return canvas;
    },
    async onTakePhotoClick(e) {

      try {
        // this.unsavedImgCount++
        e.preventDefault();
        e.stopPropagation();

        this.isRecording = true

        if (window?.navigator?.vibrate) {
          window.navigator.vibrate([200])
        }

        let audio = document.getElementById('cameraAudio');
        audio.play().catch(e => {
          console.log('audio.catch:', e)
        })

        let video = document.getElementById("preview");
        let canvas = this.createThumbnail(video, 1);

        await canvas.toBlob((blob) => {
          setTimeout(() => {
            this.isRecording = false;
            this.savePhoto(blob);
          }, 100)
        });
      } catch (error) {
        // this.unsavedImgCount = this.savedImgCount
        this.saveError(error)
      }
    },
    resizeFile(file, width = undefined, height = undefined, quality = 0.7) {
      return new Promise((resolve) => {
        let image = new Image();
        image.src = URL.createObjectURL(file);
        image.onload = function() {
          let imageWidth = image.width;
          let imageHeight = image.height;
          let canvas = document.createElement('canvas');

          if (width && height) {
            canvas.width = width;
            canvas.height = height;
          } else if (width) {
            canvas.width = width;
            canvas.height = Math.floor(imageHeight * width / imageWidth)
          } else if (height) {
            canvas.width = Math.floor(imageWidth * height / imageHeight);
            canvas.height = height;
          } else {
            canvas.width = imageWidth;
            canvas.height = imageHeight
          }

          var ctx = canvas.getContext("2d");
          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

          let dataUrl = canvas.toDataURL("image/jpeg", quality);
          resolve(dataUrl);
        }
      }).then(dataUrl => {
        return dataUrl;
      })
    },
    savePhoto(imageBlob) {
      this.resizeFile(imageBlob).then(dataUrl => {
        this.photos.push(dataUrl)
        return

        Axios.post('/fe/card/upload-files', {file: dataUrl}).then(r => {
          if (r?.data?._status) {
            this.onClickDone(r.data.file_id)
          }
        })

      })
    },
    async startVideo() {
      let width = 1280;
      let height = 720;
      // if (this.userInfo.resolution) {
      //   let r = this.userInfo.resolution;
      //   if (r == 'sd') {
      //     width = 720;
      //     height = 480;
      //   } else if (r == 'hd') {
      //     width = 1280;
      //     height = 720;
      //   } else if (r == 'full') {
      //     width = 1920;
      //     height = 1080;
      //   } else if (r == '2k') {
      //     width = 2048;
      //     height = 1080;
      //   } else if (r == '4k') {
      //     width = 3480;
      //     height = 2160;
      //   }
      // }
      if (this.activeVideoStream) {
        this.activeVideoStream.getTracks().forEach(track => track.stop());
      }
      try {
        this.activeVideoStream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: this.currentCameraMode ,
            width: { ideal: width },
            height: { ideal: height }
          }
        });
        document.getElementById("preview").srcObject = this.activeVideoStream;
      } catch (error) {
        this.saveError(error)
      }
    },
  }
}
</script>

<style scoped>
.close-web-camera{
  position: absolute;
  font-size: 34px;
  left: 30px;
  top: 15px;
  text-align: center;
  padding-top: 3px;
  width: 50px;
  height: 50px;
  border-radius: 100px;
  background-color: #fdfdfd;
  z-index: 9999;
}
.user-mode {
  transform: scaleX(-1)
}
.switch-camera {
  position: absolute;
  z-index: 9999;
  cursor: pointer;
  right: 30px;
  transform: translateY(15px);
}

.switch-camera-wrapper {
  background-color: white;
  border-radius: 100px;
  width: 50px;
  height: 50px;
}

.switch-camera .bx-camera {
  color: black;
  font-size: 26px;
  transform: translate(12px, 14px);

}

.switch-camera .switch-number {
  color: black;
  width: 10px;
  transform: translate(34px, -28px);
  font-weight: bold;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.web-video-containter {
  min-height: 100vh;
  height: auto;
  z-index: 100001;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: #1C1F3A;
}
@media (orientation: landscape) {
  .web-video-containter {
    width: 100vw;
    height: 100%;
    overflow: hidden;
    min-height: auto;
  }
  .actions{
    flex-direction: column;
    right: 0 !important;
    left: auto !important;
    height: 50vh !important;
    width: 100px;
    padding-top: 0px !important;
  }
  .switch-number{
    transform: translate(24px, -25px) !important;
    font-size: 12px;
  }
  .actions .waves-light{
    position: relative;
    top: -20px;
  }
  .btn-shot{
    margin-left: 0;
    position: relative;
    top: -22px;
    margin-top: 0px;
  }
  .bx-camera{
    font-size: 21px !important;
    transform: translate(9px, 12px) !important;
  }
  .switch-camera-wrapper{
    width: 40px;
    height: 40px;
  }
}
#preview {
  flex: 1;
  width: 100%;
  /*height: 100%;*/
  /*max-height: 100vh;*/
  object-fit: cover;
  height: 100vh;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 10vh;
}

#take-photo {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  background-color: grey;
  border: 3px solid white;
}

.red-take-photo {
  background-color: red !important;
  width: 60px !important;
  height: 60px !important;
}

</style>
